'use strict';

var $ = require('jquery');
var EgressIntent = require('egress-intent').default;
var magnific = require('magnific-popup');

function init() {
	initializeModal();
}

function initializeModal() {
	var modalSrc = document.getElementById('newsletterModal');
	if (!modalSrc)
		return;

	var modal = new EgressIntent({
		delay: 200,
		directions: 'top',
		callback: function() {
			$.magnificPopup.open({
				items: {
					src: '#newsletterModal',
					type: 'inline'
				}
			});
		}
	});

	/* $(document).on('ajaxComplete', function(event) {
		if (modal) {
			modal.disable({ cookieExpire: 1 });
		}
	});

	$('form').on('change', function() {
		if (modal) {
			modal.disable({ cookieExpire: 1 });
		}
	}) */
}

module.exports = {
	init: init
}
